import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { MapPin } from "lucide-react";

const COUNTRY_IMG = {
  FR: "https://images.unsplash.com/photo-1594796515439-da2faa37737f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxyb2FkJTIwdHJpcCUyMGZyYW5jZXxlbnwwfHx8fDE3ODgwODIwODZ8MA&ixlib=rb-4.1.0&q=85",
  CH: "https://images.unsplash.com/photo-1628062203973-88811f7fb705?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxkcml2aW5nJTIwc3dpc3MlMjBhbHBzfGVufDB8fHx8MTc4ODA4MjA4Nnww&ixlib=rb-4.1.0&q=85",
  IT: "https://images.unsplash.com/photo-1533656338503-b22f63e96cd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxkcml2aW5nJTIwYW1hbGZpJTIwY29hc3QlMjBpdGFseXxlbnwwfHx8fDE3ODgwODIwODZ8MA&ixlib=rb-4.1.0&q=85",
};

export default function Countries() {
  const [countries, setCountries] = useState([]);
  const { t } = useTranslation();
  useEffect(() => { api.get("/countries").then(({ data }) => setCountries(data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 py-14 paper-noise min-h-[70vh]">
      <span className="text-xs tracking-[0.25em] uppercase font-semibold text-[#E06D53]">{t("countries.badge")}</span>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tighter text-[#2C2A28] mt-3 mb-10">{t("countries.title")}</h1>
      <div className="grid md:grid-cols-3 gap-6">
        {countries.map((c, i) => (
          <motion.div key={c.code} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}>
            <Link to={`/pays/${c.code}`} className="block bg-white rounded-2xl border border-[#E5E0D8] overflow-hidden tc-card-hover" data-testid={`country-link-${c.code}`}>
              <div className="h-48 relative">
                <img src={COUNTRY_IMG[c.code]} alt={c.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-serif text-3xl">{c.flag} {c.name}</div>
              </div>
              <div className="p-6">
                <p className="text-sm text-[#5C5854] leading-relaxed">{c.tagline}</p>
                <span className="inline-flex items-center gap-1 text-[#E06D53] text-sm font-medium mt-4"><MapPin className="w-4 h-4" /> {t("countries.cardNote")}</span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
